import { TypeCodeTranslation } from './shared.model';

export interface BusinessRimLine {
  id: number;
  sequence: number;
  amount: string;
  description: string;
  vatPercentageTC: string;
  vatThresholdTC: string;
  amount80: string;
  invoicePresent: boolean;
  rimSectionTC: string;
  rimItemTC: string;
  vatEnabled: boolean;
  vatPercentageEnabled: boolean;
  amountEnabled: boolean;
  invoicePresentEnabled: boolean;
  rimItemValuesBySection: TypeCodeTranslation[];
  deleted: boolean;
  isImportFromDacca: boolean;
}

export function createBusinessRimLine(): BusinessRimLine {
  return {
    id: 0,
    sequence: 0,
    amount: '',
    description: '',
    vatPercentageTC: '',
    vatThresholdTC: '',
    amount80: '',
    invoicePresent: false,
    rimSectionTC: '',
    rimItemTC: '',
    vatEnabled: false,
    vatPercentageEnabled: false,
    amountEnabled: false,
    invoicePresentEnabled: false,
    rimItemValuesBySection: [],
    deleted: false,
    isImportFromDacca: false
  };
}

export interface BusinessRim {
  id: number;
  currentRimLine: BusinessRimLine;
  rimLines: BusinessRimLine[];
  deductibleVatPercentage: number | '';
  vat6ToBeJustifiedAmount: number | '';
  vat21ToBeJustifiedAmount: number | '';
  paidByBankTransfer: boolean;
  bban: string;
  iban: string;
  bicCode: string;
  rimLinesAmountTotal: number;
  rimLinesAmount80Total: number;
  vatThresholdValues: TypeCodeTranslation[];
  vatPercentageValues: TypeCodeTranslation[];
  rimSectionValues: TypeCodeTranslation[];
  rimItemValues: TypeCodeTranslation[];
  damageCauseRemark: string;
  sendEmailToPolicyHolder: boolean | '';
  emailPolicyHolder: string;
  sendEmailToCounterExpert: boolean | '';
  emailCounterExpert: string;
  sendEmailToPersonalExpert: boolean | '';
  emailPersonalExpert: string;
  sendEmailToOther: boolean | '';
  emailOther: string;
  rimStatusTC: string;
}

export function createBusinessRim(): BusinessRim {
  return {
    id: 0,
    currentRimLine: createBusinessRimLine(),
    rimLines: [],
    deductibleVatPercentage: 0,
    vat6ToBeJustifiedAmount: 0,
    vat21ToBeJustifiedAmount: 0,
    paidByBankTransfer: false,
    bban: '',
    iban: '',
    bicCode: '',
    rimLinesAmountTotal: 0,
    rimLinesAmount80Total: 0,
    vatThresholdValues: [],
    vatPercentageValues: [],
    rimSectionValues: [],
    rimItemValues: [],
    damageCauseRemark: '',
    sendEmailToPolicyHolder: false,
    emailPolicyHolder: '',
    sendEmailToCounterExpert: false,
    emailCounterExpert: '',
    sendEmailToPersonalExpert: false,
    emailPersonalExpert: '',
    sendEmailToOther: false,
    emailOther: '',
    rimStatusTC: '',
  }
}